module.exports = __webpack_public_path__ + "img/icon_map.7b80d5b8.svg";